import React from "react";
import { useRoutes } from "react-router-dom";
import ROUTES from "./routes";

import CmsHome from "../pages/cms";

const CustomRoutes = (props) => {
  let element = useRoutes(ROUTES);
  if (props.location.includes("/cms")) {
    return <CmsHome location={props.location} />;
  }
  return element;
};
export default CustomRoutes;
